import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { showError, showSuccess } from '@/lib/dialogHelper'
import LoadingIndicator from '@/widgets/LoadingIndicator'
import CustomCollectionForm from '../common/CustomCollectionForm'
import useFormData from '../common/useFormData'
import useEditFormData from '../common/useEditFormData'
import EditCollectionForm from '../common/EditCollectionForm'

/*
useFormData - based on collectionId anditemId - loads the item into *formData*, also gets collectionDetails with schema

- edit page gets collectionId and id from params
- uses useFormData to load collectionDetails and formData with field name-> value

//
- passes these to CustomCollectionForm
- onChange of CustomCollectionForm updates formData via useFormData's setFieldValue
- onSubmit of CustomCollectionForm triggers handleSubmit which calls update API

*/
export default function SingleCustomCollectionEdit() {
	const { t } = useTranslation()
	const { collectionId, id } = useParams()
	const navigate = useNavigate()
	const { collectionDetails, formData, loading, error, setFieldValue, saveFormData } = useEditFormData({ collectionId, itemId: id })

	if (loading) { return <LoadingIndicator message={t('singleCustomCollection.edit.loading')} /> }
	if (error) { showError(error) ; }

	const handleSave = async () => {
		// console.log(`Will save collectionid ${collectionId} itemid ${id}:`, formData)
		const {data, error} = await saveFormData()
		// console.log(`TCL -> index.jsx:35 -> handleSave -> data, error}:`, data, error)
		if (error) return showError(t('singleCustomCollection.edit.messages.saveFailed', { error }));
		if (data) return navigate(`/single-custom-collection/${collectionId}/details/${data._id}`);
	}

	return (
		<div>
			<EditCollectionForm
				title={t('singleCustomCollection.edit.title', { name: collectionDetails?.displayName || collectionDetails?.name })}
				description={t('singleCustomCollection.edit.description', { name: collectionDetails?.displayName || collectionDetails?.name })}
				collectionDetails={collectionDetails}
				formData={formData}
				onFieldChange={setFieldValue}
				onSave={() => handleSave()}
				submitLabel={t('singleCustomCollection.edit.actions.save')}
			/>
		</div>
	)
}
